module.exports = __webpack_public_path__ + "img/selectedOff.1dbf25ab.svg";